import { useUser } from '@clerk/clerk-react'
import type { CategoryConfigSection } from '@/lib/api/med-requests/category-config'

// Managers (LEAD_PRESCRIBER / CS_PHARMACY_MANAGER) configure the lists; everyone the lists apply to
// (PRESCRIBER / JUNIOR_PRESCRIBER / TRIAL_PRESCRIBER / PHARMACIST) sees the curated chips instead.
export const useCategoryConfigAccess = () => {
  const { user } = useUser()
  const roles = user?.publicMetadata.roles ?? []

  const isLeadPrescriber = roles.includes('LEAD_PRESCRIBER')
  const isPharmacyManager = roles.includes('CS_PHARMACY_MANAGER')

  const categoryConfigSection: CategoryConfigSection | null = isLeadPrescriber
    ? 'prescribers'
    : isPharmacyManager
      ? 'pharmacists'
      : null

  return { categoryConfigSection }
}
